import type Listing from 'data/listing';

/**
 * Determines whether a listing belongs to eXp Realty.
 *
 * A listing/property is considered an eXp listing when:
 * - Listing has `isExpListing: true` (go-search property or client-app `is-exp-listing`), OR
 * - It has an `expAgentId` (listing agent is an eXp agent), OR
 * - Any agent in `agentsInfo` has a non-null `exp_member_key`
 */
export function isExpListing(
  listing: Pick<Listing, 'expAgentId' | 'agentsInfo' | 'isExpListing'>
): boolean {
  if ('isExpListing' in listing && listing.isExpListing === true) return true;
  if (listing.expAgentId) return true;
  if (listing.agentsInfo?.some(a => a.exp_member_key != null)) return true;
  return false;
}
